/**
 * @name BulkOrderPLP_DynamicTables.ItemLines.View.js
 *
 * @author Anchor Group : Anthony Dittus <adttus@anchorgroup.tech>
 * @since 2024-02-29
 * 
 * @file Item Cell Level View replicating the List View Cell
 * 
 */


define('BulkOrderPLP_DynamicTables.ItemLines.View',
	[
		'bulkorderplp_dynamictables_itemlines.tpl',
		'Backbone'
	],
	function (
		bulkorderplp_dynamictables_itemlines_tpl,
		Backbone
	) {
		'use strict';

		return Backbone.View.extend({
			template: bulkorderplp_dynamictables_itemlines_tpl,

			initialize: function (options) {
				this.CartComponent = options.CartComponent;
				this.hidePricing = options.hidePricing;
				this.LayoutComponent = options.LayoutComponent;
				this.application = options.application;


				//* Get and process the item data and column config
				this.itemModel = this.model;
				this.itemModel.set('displayOutOfStock', this.itemModel.get('isinstock') == false && this.itemModel.get('isbackorderable') == false);

				this.loginUrlRedirect = window.location.origin + SC.SESSION.touchpoints.register + "&fragment=login-register&origin=" + SC.CONFIGURATION.currentTouchpoint + "&origin_hash=" + encodeURIComponent(Backbone.history.fragment);

				let configObj = this.itemModel.get('configObj');

				this.customColumnDisplayArray = new Array;
				if (this.itemModel.get('isHeader')) {
					for (let i = 1; i < 11; i++) {
						this.customColumnDisplayArray.push({
							columnItemID: configObj['customColumnFieldID' + i],
							customColumnHeader: configObj['customColumnHeader' + i]
						})
					}
				} else {
					for (let i = 1; i < 11; i++) {
						if (configObj && configObj['customColumnFieldID' + i]) {
							this.customColumnDisplayArray.push({
								columnItemID: configObj['customColumnFieldID' + i],
								columnItemValue: this.itemModel.get(configObj['customColumnFieldID' + i]),
								customColumnHeader: configObj['customColumnHeader' + i]
							});
						}
					}
				}
			},

			events: {
				'click [data-type="add-to-cart"]': 'addToCart'
			},


			/**
			 * Add the value of the quantity selector into the cart
			 * @function  addToCart
			 */
			addToCart: _.debounce(function (e) {
				let self = this;
				let itemQuantity = JSON.parse($('input[name="quantity"][data-id="' + this.itemModel.id + '"]:visible').val());

				if (itemQuantity > 0) {
					if (this.itemModel.get('displayOutOfStock') == true) {
						this.CartComponent.showMessage({
							message: 'Out of Stock',
							type: 'error',
							selector: 'addToCart_' + self.itemModel.id,
							timeout: 4000
						});
					} else {
						this.CartComponent.addLine({
							line: {
								quantity: itemQuantity,
								item: {
									internalid: self.itemModel.id
								}
							}
						}).fail(function (response) {
							let error = response.responseJSON;

							self.CartComponent.showMessage({
								message: error.errorMessage,
								type: 'error',
								selector: 'addToCart_' + self.itemModel.id,
								timeout: 4000
							});
						}).then(function (response) {
							self.CartComponent.showMessage({
								message: "Cart Addition Successful",
								type: 'success',
								selector: 'addToCart_' + self.itemModel.id,
								timeout: 3000
							});
						});
					}
				}
			}, 300),

			getContext: function getContext() {
				return {
					categorySectionIndex: this.itemModel.get('categorySectionIndex'),
					customColumnDisplayArray: this.customColumnDisplayArray,

					thumbnail: this.itemModel.get('_thumbnail'),
					url: this.itemModel.get('_url') || 'product/' + this.itemModel.get('internalid'),
					itemID: this.itemModel.get('internalid'),
					sku: this.itemModel.get('itemid'),
					storeDescription: this.itemModel.get('storedescription'),

					quantityOnOrder: this.itemModel.get('quantityonorder') || 0,
					quantityAvailable: this.itemModel.get('quantityavailable'),

					onlinecustomerprice_formatted: this.itemModel.get('onlinecustomerprice_formatted'),
					hidePricing: this.hidePricing,
					loginUrlRedirect: this.loginUrlRedirect
				};
			}
		});
	});
